<div
  class="radio-control grit-radio-control"
  (focus)="onFocus()"
  tabindex="0"
  (click)="onClick($event)"
  [attr.aria-labelledby]="getId()"
  (blur)="onBlur()"
  (keydown)="handleKeyDown($event)"
  #radioCircleElement
></div>
<div
  class="pg-radio-content grit-radio-content font-body-s"
  [style.font-family]="fontFamily"
  [style.font-weight]="fontWeight"
  (click)="onClick($event)"
  [attr.id]="getId()"
>
  <ng-content></ng-content>
</div>
